import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import BackButtonDesktop from '../../components/BackButtonDesktop';

export default function PrivacyPolicy() {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Privacy Policy di www.deskstudio.it
      </Typography>
      <Typography variant="subtitle2" gutterBottom>
        Ultimo aggiornamento: 6 Febbraio 2026
      </Typography>

      <Box sx={{ mt: 3 }}>
        <Typography variant="h6">1. Raccolta dei dati</Typography>
        <Typography paragraph>
          Raccogliamo dati personali degli utenti quando utilizzano il nostro sito e i nostri servizi, ad esempio:
        </Typography>
        <ul>
          <li>Nome e cognome</li>
          <li>Indirizzo email</li>
          <li>Dati di pagamento (tramite Stripe)</li>
          <li>Informazioni relative all’utilizzo del sito (cookie, analisi traffico)</li>
        </ul>

        <Typography variant="h6">2. Finalità del trattamento</Typography>
        <Typography paragraph>
          I dati raccolti vengono utilizzati esclusivamente per:
        </Typography>
        <ul>
          <li>Fornire i servizi richiesti (gestione contratti, pagamenti online)</li>
          <li>Invio di comunicazioni relative ai servizi o aggiornamenti importanti</li>
          <li>Analisi anonime sul traffico e l’utilizzo del sito</li>
        </ul>

        <Typography variant="h6">3. Conservazione dei dati</Typography>
        <Typography paragraph>
          I dati personali vengono conservati per il tempo strettamente necessario alle finalità sopra indicate, salvo obblighi di legge.
        </Typography>

        <Typography variant="h6">4. Condivisione dei dati</Typography>
        <Typography paragraph>
          I dati possono essere condivisi con fornitori terzi solo se necessario per erogare i servizi, ad esempio:
        </Typography>
        <ul>
          <li>Stripe, per la gestione dei pagamenti</li>
          <li>Servizi email per l’invio di comunicazioni</li>
        </ul>

        <Typography variant="h6">5. Diritti dell’utente</Typography>
        <Typography paragraph>
          L’utente ha diritto di:
        </Typography>
        <ul>
          <li>Accedere ai propri dati</li>
          <li>Richiederne la correzione o l’aggiornamento</li>
          <li>Richiederne la cancellazione</li>
        </ul>
        <Typography paragraph>
          Per esercitare questi diritti, puoi scrivere a <strong>privacy@[iltuosito].it</strong>.
        </Typography>

        <Typography variant="h6">6. Cookie e tracciamento</Typography>
        <Typography paragraph>
          Utilizziamo cookie tecnici per il corretto funzionamento del sito e cookie di analisi anonimi. L’utente può gestire le preferenze dei cookie dal browser.
        </Typography>

        <Typography variant="h6">7. Contatti</Typography>
        <Typography paragraph>
          Per qualsiasi domanda sulla privacy, contatta <strong>privacy@deskstudio.it</strong>.
        </Typography>
      </Box>
            <BackButtonDesktop />
    </Container>
  );
}